module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/faq/faq.component.css
// module id = ./src/app/components/faq/faq.component.css
// module chunks = main